import React from "react";
import "./Loader.scss";

const Loader = ({ className, textColor }) => {
    return (
        <div className="wrapperLoader">
            <Loading className={className} textColor={textColor} />
        </div>
    );
};

export const Loading = ({ className ,textColor}) => (
    <div
        className={`buttonLoader spinner ${className}`}
        style={textColor && { borderTopColor: textColor }}
    />
);

export default Loader;